import 'polyfills/promiseWithResolvers';
import React from 'react';
import '@populateui/core/defaults.css';
import 'styles/globals.css';
import { ThemeProvider } from '@mui/material';
import { AppProps } from 'next/app';
import { Provider } from 'react-redux';
import {
  QueryClient,
  QueryClientProvider,
} from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import { store } from 'store/store';
import { theme } from 'utils/theme';
import NotificationProvider from 'contexts/notification';
import FileViewerProvider from 'contexts/fileViewer';
import ConfirmationDialogProvider from 'contexts/confirmationDialog';
import { useGoogleMaps } from 'components/common/hooks';
import 'config/datadogBrowserLogs';

// Create a client
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 5 * 60 * 1000, // 5 minutes
      gcTime: 10 * 60 * 1000, // 10 minutes (renamed from cacheTime in v5)
      retry: 1,
      refetchOnWindowFocus: false,
    },
  },
});

function MyApp({ Component, pageProps }: AppProps) {
  useGoogleMaps();
  return (
    <QueryClientProvider client={queryClient}>
      <Provider store={store}>
        <ThemeProvider theme={theme}>
          <NotificationProvider>
            <FileViewerProvider>
              <ConfirmationDialogProvider>
                <Component {...pageProps} />
              </ConfirmationDialogProvider>
            </FileViewerProvider>
          </NotificationProvider>
        </ThemeProvider>
      </Provider>
      <ReactQueryDevtools initialIsOpen={false} />
    </QueryClientProvider>
  );
}

export default MyApp;
